// test2575
(2575 && 0);
